import React from 'react';
import { RefTexts } from '../contexts/LangRef';
import ReferanceFinancial from './Referance-financial';

function Referance({ lang = 'ko' }) {
  return (
    <div
      style={{
        minHeight: '100vh',
        background: '#035BFB',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        padding: '48px 16px'
      }}
    >
      <h1 style={{
        fontSize: '2.5rem',
        fontWeight: 700,
        color: '#ffffffff',
        marginTop: 60,
        marginBottom: 40,
        textAlign: 'center'
      }}>
        <br />{RefTexts.title[lang]}
      </h1>
      {/* 여기에 사례 내용을 추가하세요 */}
      <ReferanceFinancial lang={lang}/>
    </div>
  );
}

export default Referance;